import React from 'react'
import { connect } from 'react-redux'
import { Trans } from 'react-i18next'
import i18next from 'i18next'
import hash from 'object-hash'
import { getConstants } from 'src/lib/constants'
import { Button, Modal, Form, Card, Badge } from 'react-bootstrap'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import SearchButton from 'src/components/system_wide/search_button'

import { getAppointments, resetContractAppointments } from 'src/store/contracts'
import { format, parseISO } from 'date-fns'
import FilterGroup from '../system_wide/filter_group'
import CheckboxFilter from '../system_wide/checkbox_filter'
import SelectAgentsModal from '../system_wide/select_agents_modal'

const { t } = i18next

const mstp = state => {
  let { id: user_id, business_role_priority } = state.userInfo
  let { appointments } = state.contracts
  let { all_users: users } = state.users
  let { all_brands: brands } = state.brands
  return { user_id, business_role_priority, appointments, users, brands }
}

const styles = {
  add_modal: {
    minHeight: '55vh',
  },
  add_table: {
    /* border-bottom: solid 0.15rem var(--bs-primary); */
    boxShadow: 'none',
  },
}
class SelectAppointmentModal extends React.Component {
  static defaultProps = {
    selected: null,
    required: false,
    disabled: false,
    readonly: false,
    created_by: null,
    className: '',
    style: {},

    onChange: () => {},
  }

  state = {
    show: false,
    ready: false,
    selected_appointment: null,
    filtered_brands: [],
    filtered_users: [],
    filtered_statuses: ['concluded'],
    filter: '',
  }

  tableRef = null
  selectAgentsModalRef = null
  filter_statuses = []
  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
    this.selectAgentsModalRef = React.createRef()
    this.state.selected_appointment = this.props.selected_appointment
    this.filter_statuses = getConstants().appointment_statuses
    this.filter_statuses = Object.keys(this.filter_statuses).map(k => ({ id: k, name: this.filter_statuses[k] }))
  }

  getData = async (index = 0, chunkSize, sortData, filter) => {
    let { ready, filtered_brands, filtered_users, filtered_statuses } = this.state
    if (!ready) return
    await this.props.dispatch(
      getAppointments({
        offset: index,
        limit: chunkSize,
        sortData,
        filter,
        filtered_brands,
        filtered_users,
        filtered_statuses,
        filtered_types: ['engagement'],
      })
    )
  }

  componentDidUpdate(prevProps) {
    if (hash(prevProps.selected) !== hash(this.props.selected)) {
      this.setState({ selected_appointment: this.props.selected })
    }
  }

  show = async () => {
    await this.tableRef?.currenrt?.refresh()
    this.setState(
      {
        show: true,
        selected_appointment: this.props.selected,
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_users: this.props.created_by ? [this.props.created_by] : this.props.users.map(u => u.id),
        ready: true,
      },
      () => {
        this.tableRef?.current?.refreshData()
      }
    )
  }

  hide = () => {
    this.setState({ show: false, ready: false })
    this.props.dispatch(resetContractAppointments())
  }

  toggleAppointments = ({ target: { value } }) => {
    const { appointments } = this.props
    let appointment = appointments.appointments.find(a => a.id.toString() === value)
    this.setState({ selected_appointment: appointment })
  }

  selectAppointmentRadio = ({ rowData }) => {
    let { selected_appointment } = this.state

    return (
      <Form.Check
        type="radio"
        className="py-1"
        value={rowData.id}
        checked={selected_appointment?.id ? selected_appointment.id === rowData.id : false}
        onChange={this.toggleAppointments}
      />
    )
  }

  renderStatus(rowData) {
    const { status, rejected_note } = rowData
    const _filter_statuses = this.filter_statuses.reduce((acc, s) => ({ ...acc, [s.id]: s.name }), {})
    const statusMap = {
      concluded: { text: _filter_statuses['concluded'], color: 'success' },
      rejected: { text: _filter_statuses['rejected'], color: 'danger' },
      pending: { text: _filter_statuses['pending'], color: 'warning' },
    }

    const { text, color } = statusMap[status]
    return (
      <div className="text-center">
        <Badge bg={color} className="px-3 py-2 text-uppercase shadow-sm" style={{ fontSize: '1rem' }}>
          {text}
        </Badge>
        {status === 'rejected' && rejected_note && (
          <div className="text-muted small mt-1 px-2">
            <em>{rejected_note}</em>
          </div>
        )}
      </div>
    )
  }

  renderDetails(rowData) {
    const {
      date,
      dealer_brand: { dealer, brand },
      created_by,
      code,
    } = rowData
    let { piva, business_name, address } = dealer
    let fullname = created_by ? created_by.first_name + ' ' + created_by.last_name : ''
    let brand_name = brand?.name ?? ''
    const value = this.props.business_role_priority === 4 ? business_name : code

    return (
      <Card className="shadow-lg border-0 rounded-lg">
        <Card.Body className="pb-2 pt-2">
          <h5 className="fw-bold text-primary d-flex d-block align-items-center">
            {this.selectAppointmentRadio({ rowData })} <span className="ms-2 pt-1">{value}</span>
          </h5>
          <p className="text-muted mb-1">
            <i className="fas fa-calendar-alt me-2"></i>
            {format(parseISO(date), 'dd/MM/yyyy HH:mm')}
          </p>
          <p className="text-muted mb-1">
            <i className="fas fa-tag me-2"></i>
            {brand_name}
          </p>
          {this.props.business_role_priority !== 4 && (
            <p className="text-muted mb-1">
              <i className="fas fa-building me-2"></i>
              {business_name} ({piva})
            </p>
          )}
          <p className="text-muted mb-1">
            <i className="fas fa-map-marker-alt me-2"></i>
            {address}
          </p>
          {this.props.business_role_priority !== 4 && (
            <p className="text-muted mb-1">
              <i className="fas fa-user me-2"></i>
              {fullname}
            </p>
          )}
        </Card.Body>
      </Card>
    )
  }

  columns = [
    {
      title: '',
      className: 'd-none d-sm-block text-center',
      style: { width: '5%', minWidth: '3rem' },
      data: this.selectAppointmentRadio,
    },
    {
      name: 'code',
      title: t('components.appointments.code', 'Codice'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      data: 'code',
    },
    {
      title: t('components.appointments.date', 'Data'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'date',
      data: ({ rowData: { date } }) => {
        return format(parseISO(date), 'yyyy/MM/dd HH:mm')
      },
    },
    {
      title: t('components.appointments.brand', 'Brand'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'brand_name',
      data: ({ rowData: { dealer_brand } }) => {
        return dealer_brand?.brand?.name ?? ''
      },
    },
    {
      title: t('components.appointments.business_name', 'Ragione sociale'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'dealer_business_name',
      data: ({ rowData: { dealer_brand } }) => {
        let { business_name, piva } = dealer_brand?.dealer
        return (
          <div>
            {business_name} <br />
            {piva}
          </div>
        )
      },
    },
    {
      title: t('components.appointments.address', 'Indirizzo'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'dealer_address',
      data: ({ rowData: { dealer_brand } }) => {
        return dealer_brand?.dealer?.address ?? ''
      },
    },
    {
      name: 'created_by',
      title: t('components.appointments.created_by', 'Creato da'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'created_by_name',
      data: ({ rowData: { created_by } }) => {
        let fullname = created_by?.first_name + ' ' + created_by?.last_name
        return fullname
      },
    },
    {
      title: t('components.appointments.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      data: ({ rowData }) => this.renderDetails(rowData),
    },
  ]

  getColumns = () => {
    if (this.props.business_role_priority === 4) {
      return this.columns.filter(column => column.name !== 'code' && column.name !== 'created_by')
    }
    return this.columns
  }

  onFilterChange = filter => this.setState({ filter })

  onChangeFilter = name => values => {
    if (name === 'filtered_users') {
      values = values.map(user => user.id)
    }
    this.setState({ [name]: values }, () => {
      this.tableRef?.current?.refreshData()
    })
  }

  handleConfirm = () => {
    let { selected_appointment } = this.state
    let { id, date, code, created_by, note, dealer_brand } = selected_appointment
    let appointment = {
      id,
      date,
      code,
      note,
      created_by: created_by.id,
      brand_name: dealer_brand?.brand?.name ?? '',
      dealer_brand_id: dealer_brand?.id,
      dealer: {
        id: dealer_brand?.dealer?.id ?? null,
        business_name: dealer_brand?.dealer?.business_name ?? '',
        piva: dealer_brand?.dealer?.piva ?? '',
        address: dealer_brand?.dealer?.address ?? '',
      },
    }
    this.props.onChange(appointment)
    this.hide()
  }

  onRowClick = rowData => {
    if (rowData.enabled === false && this.state.selected_appointment.id !== rowData.id.toString()) {
      return
    }
    const event = { target: { value: rowData.id.toString() } }
    this.toggleAppointments(event)
  }

  render() {
    let { show, filter, filtered_brands, filtered_users } = this.state
    let { required, disabled, readonly, selected, appointments, brands, users, user_id, created_by } = this.props
    let show_filter_agents = users?.length > 0 && users?.[0]?.id !== user_id && !created_by
    return (
      <>
        <div className={`${this.props.className}`} style={this.props.style}>
          <Form.Label>
            <Trans i18nKey="components.users.appointments">Visita</Trans>
            {required === true && <span> *</span>}
          </Form.Label>
          <div className="mt-1 d-flex flex-row align-items-center mb-3">
            <div className="d-flex flex-row align-items-center ms-2">
              <div className="text-muted">
                <>
                  {!selected && (
                    <em>{t('components.users.no_selected_appointment_label', 'Nessuna visita selezionata')}</em>
                  )}
                  {selected && (
                    <>
                      <b>{selected.code}</b>
                      <span className="ms-1">
                        <Trans i18nKey="components.users.appointment_selected">selezionato</Trans>
                      </span>
                    </>
                  )}
                </>
              </div>
              {readonly === false && (
                <Button className="ms-2" onClick={this.show} disabled={disabled}>
                  <i className="fas fa-plus fa-fw text-start me-0"></i>
                  {selected && <Trans i18nKey="components.users.edit_appointment">Modifica</Trans>}
                  {!selected && <Trans i18nKey="components.users.add_appointment">Aggiungi</Trans>}
                </Button>
              )}
            </div>
          </div>
        </div>

        <Modal backdrop="static" centered contentClassName={styles.add_modal} show={show} onHide={this.hide} size="xl">
          <Modal.Header>
            <Modal.Title>
              <Trans i18nKey="components.users.appointment_modal.title_selected">Seleziona una visita</Trans>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column flex-fill" style={{ height: '60vh' }}>
            <div className="toolbar px-2 flex-wrap">
              <FilterGroup className="toolbar-item">
                <CheckboxFilter
                  label={t('filter_brands', 'Brand')}
                  items={brands}
                  filteredItems={filtered_brands}
                  onChangeFilter={this.onChangeFilter('filtered_brands')}
                  showSearch={true}
                />

                {show_filter_agents === true && (
                  <Button
                    className="dropdown-toggle btn btn-primary"
                    onClick={() => this.selectAgentsModalRef.current.show({ selected_users: filtered_users })}>
                    <Trans i18nKey="filter_agents">Funzionari</Trans>
                  </Button>
                )}
              </FilterGroup>
              <div className="toolbar-spacer"></div>
              <div className="flex-fill">
                <SearchButton
                  value={filter}
                  onChange={this.onFilterChange}
                  disabled={this.props.show_form}
                  className="float-md-end"
                />
              </div>
            </div>

            <ResponsiveTable
              ref={this.tableRef}
              className={`flex-fill ${styles.add_table}`}
              data={appointments.appointments}
              getData={this.getData}
              totalRecords={appointments.total}
              columns={this.getColumns()}
              rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
              filter={filter}
              onRowClick={readonly === false && this.onRowClick}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hide} variant="secondary">
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button onClick={this.handleConfirm} variant="primary">
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          </Modal.Footer>
        </Modal>

        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={users}
          brands={brands}
          selected_user={filtered_users}
          onChange={this.onChangeFilter('filtered_users')}
          multiSelection={true}
        />
      </>
    )
  }
}

export default connect(mstp, null, null, { forwardRef: true })(SelectAppointmentModal)
